import {Box, Card, Grid} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithNoMarks} from '../../../../utils'
import type {IntroSectionProps} from '../types'
import styles from '../IntroSection.module.css'

type Props = Pick<IntroSectionProps, 'introIconCards'>

export function IntroIconCards({introIconCards}: Props) {
  if (!introIconCards || introIconCards.length === 0) return null

  return (
    <Box className={styles.cardGridFrame}>
      <Grid className={styles.gridContent}>
        {introIconCards.map(item => {
          const IconComponent = getPrimerIcon(item.fields.icon)
          return (
            /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
            <Grid.Column key={item.sys.id} span={{medium: 4}} className="gridColumn">
              <Box
                className={styles.gridItem}
                padding={{narrow: 24, regular: 40}}
                paddingBlockStart={{regular: 80}}
                paddingBlockEnd={{regular: 80}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Card href={item.fields.href} variant="minimal" fullWidth ctaText={item.fields.label}>
                  {IconComponent ? <Card.Icon icon={<IconComponent />} color="default" hasBackground /> : null}
                  {item.fields.eyebrow ? <Card.Label>{item.fields.eyebrow}</Card.Label> : null}
                  <Card.Heading>
                    {renderWithNoMarks(item.fields.heading)}
                    {item.fields.alt ? <span className="sr-only"> {item.fields.alt}</span> : null}
                  </Card.Heading>
                  <Card.Description>{renderWithNoMarks(item.fields.description)}</Card.Description>
                </Card>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
